import React, { createContext, useContext, useEffect, useState } from 'react';

import convertToArray from '../helpers/list';
import { useFirebase } from './Firebase';
import { onValue } from '../helpers/Firebase/base';

const UsersContext = createContext(null);

const useUsers = () => useContext(UsersContext);

const UsersProvider = ({ children }) => {
  const firebase = useFirebase();

  const [users, setUsers] = useState([]);

  useEffect(() => {
    const usersRef = firebase.users();
    onValue(usersRef, (data) => {
      setUsers(convertToArray(data));
    }, { onlyOnce: true });
  }, [firebase]);

  return (
    <UsersContext.Provider value={ users }>
      {children}
    </UsersContext.Provider>
  )
};

export { UsersContext, UsersProvider, useUsers };